/**
 * JED-1347: GET /notifications is fetched once per sign-in (no polling, and the
 * header's query never refetches on mount or focus) and the header stays
 * mounted, so a task published while a student was signed in never showed up
 * until a reload. Opening the drawer refreshes a feed older than this: at most
 * one GET per open, never on a timer.
 */
export const NOTIFICATIONS_REFRESH_AFTER_MS = 60_000;

const NOTIFICATIONS_QUERY_KEY = ['notifications'];

export function refreshNotificationsIfStale(queryClient, now = Date.now()) {
  const state =
    queryClient && queryClient.getQueryState(NOTIFICATIONS_QUERY_KEY);
  // No feed in this cache (nothing to refresh) or a request already in flight.
  if (!state || state.fetchStatus === 'fetching') return false;
  if (now - (state.dataUpdatedAt || 0) < NOTIFICATIONS_REFRESH_AFTER_MS) {
    return false;
  }
  queryClient.refetchQueries({
    queryKey: NOTIFICATIONS_QUERY_KEY,
    exact: true,
  });
  return true;
}
